import { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "@/gql";

export const allSupplierDashboardBookingStatsQuery = graphql(`
  query AllSupplierDashboardBookingStats(
    $start: DateTimeTz!
    $end: DateTimeTz!
    $comparisonMode: ComparisonMode!
  ) {
    allSupplierDashboardBookingStats(
      start: $start
      end: $end
      comparisonMode: $comparisonMode
    ) {
      thisPeriod {
        successful_bookings_count
      }
      lastPeriod {
        successful_bookings_count
      }
      suppliers {
        supplier_id
        supplier_name
        pending_count
        confirmed_count
        completed_count
        cancelled_count
        avg_confirmation_hours
      }
    }
  }
`);

export type AllSupplierDashboardBookingStats = NonNullable<
  ResultOf<
    typeof allSupplierDashboardBookingStatsQuery
  >["allSupplierDashboardBookingStats"][number]
>;
